import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default function swiperMapLinks() {
    if (typeof Swiper === "undefined") return;

    const maps = document.querySelectorAll('[data-map-links]');
    if (!maps.length) return;

    // Animación secuencial en desktop
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const items = entry.target.querySelectorAll('.map-links__item');
                items.forEach((item, index) => {
                    setTimeout(() => {
                        item.classList.add('map-links__item--visible');
                    }, index * 150);
                });
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 });

    const initOrDestroy = () => {
        const isMobile = window.innerWidth < 992;

        maps.forEach((map) => {
            const container = map.querySelector('.map-links__container');
            if (!container) return;

            const hasInstance = map.swiper && !map.swiper.destroyed;
            const nextEl = map.querySelector('.map-links__next');
            const prevEl = map.querySelector('.map-links__prev');
            const pagination = map.querySelector('.map-links__pagination');
            const items = container.querySelectorAll('.map-links__item');

            // Guardar estilos originales (top/left inline) una sola vez
            items.forEach((item) => {
                if (!item.dataset.originalStyle) {
                    item.dataset.originalStyle = item.getAttribute('style') || '';
                }
            });

            if (isMobile && !hasInstance) {
                map.classList.add('swiper', 'map-links--mobile');
                container.classList.add('swiper-wrapper');
                items.forEach((item) => {
                    item.classList.add('swiper-slide');
                });

                const options = {
                    modules: [Navigation, Pagination],
                    slidesPerView: 1,
                    spaceBetween: 20,
                    centeredSlides: true,
                };

                if (nextEl && prevEl) {
                    options.navigation = { nextEl, prevEl };
                }

                if (pagination) {
                    options.pagination = {
                        el: pagination,
                        clickable: true,
                    };
                }

                map.swiper = new Swiper(map, options);
            }

            if (!isMobile && hasInstance) {
                map.swiper.destroy(true, true);
                map.swiper = null;

                // Limpiar clases y estilos que deja Swiper
                map.classList.remove('swiper', 'map-links--mobile', 'swiper-initialized', 'swiper-horizontal', 'swiper-pointer-events');
                container.classList.remove('swiper-wrapper');
                container.removeAttribute('style');
                items.forEach((item) => {
                    item.classList.remove('swiper-slide');

                    // Restaurar estilos inline originales (top/left) si existen
                    if (Object.prototype.hasOwnProperty.call(item.dataset, 'originalStyle')) {
                        const original = item.dataset.originalStyle;
                        if (original) {
                            item.setAttribute('style', original);
                        } else {
                            item.removeAttribute('style');
                        }
                    }
                });
            }
        });
    };

    maps.forEach((map) => {
        observer.observe(map);
    });

    initOrDestroy();

    if (!window._mapLinksResizeBound) {
        window._mapLinksResizeBound = true;
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(initOrDestroy, 200);
        });
    }
}
